import ACTION_TYPES from "../types";

// reducer.js
const INITIAL_STATE = {
   workbookIdListFromDB: [],
   workbookListData: [],
   selectedWorkbookId: "",
   currentSelectedWorkbook: {},
   sheetsForDownload:[],
   isWorkbookDownloading:false,
   isWorkbookListDataFetched:false,
   isWorkbookDownloadingExcelJS:false,
   exportWorkbook:null,
   sheetsExportedIntoWorkbook:[],
   workbooksExported:[],
   currentDownladingWorkbook:{},
   sharedWithMeWorkBooks : [],
   isSharedWorkbook:false,
   isWorkbookImporting: false,
   showWorkbookloader:false,
   isWorkbookDeleting:false,
}

const workbookReducer = (state = INITIAL_STATE, action) => {
	switch(action.type) {
		case ACTION_TYPES.GET_WORKBOOK_DATA:
			return {
				...state,
				workbookIdListFromDB: action.workbookIdListFromDB,
                workbookListData: action.workbookListData,
				currentSelectedWorkbook: action.currentSelectedWorkbook,
                selectedWorkbookId: action.selectedWorkbookId,
				isWorkbookListDataFetched:action.isWorkbookListDataFetched
			}
		case ACTION_TYPES.SET_WORKBOOK_DATA:
			return {
				...state,
				selectedWorkbookId: action.selectedWorkbookId ? action.selectedWorkbookId : state.selectedWorkbookId,
				workbookListData: action.workbookListData ? action.workbookListData : state.workbookListData,
				currentSelectedWorkbook: action.currentSelectedWorkbook? action.currentSelectedWorkbook : state.currentSelectedWorkbook,
				isSharedWorkbook : action.isSharedWorkbook !== undefined ? action.isSharedWorkbook : state.isSharedWorkbook ?? false,
			}
		
		case ACTION_TYPES.DELETE_WORKBOOK_ITEM:
			let newWorkbookList = state.workbookListData.filter((item)=> item.id !== action.payload.id)
			return {
				...state,
				workbookListData: newWorkbookList,
				selectedWorkbookId: newWorkbookList[0] ? newWorkbookList[0].id : "",
				currentSelectedWorkbook: state.currentSelectedWorkbook?.id === action.payload.id
					? newWorkbookList[0] || null
					: state.currentSelectedWorkbook,
			}
			case ACTION_TYPES.DOWNLOAD_WORKBOOK:
				
			return {
				...state,
				sheetsForDownload:action.payload||state.sheetsForDownload,
				isWorkbookDownloading:action.isWorkbookDownloading,
				exportWorkbook:action.exportWorkbook,
				sheetsExportedIntoWorkbook:action.sheetsExportedIntoWorkbook?action.sheetsExportedIntoWorkbook:state.sheetsExportedIntoWorkbook,
				isWorkbookDownloadingExcelJS:action.isWorkbookDownloadingExcelJS,
				workbooksExported:action.workbooksExported || state.workbooksExported,
				currentDownladingWorkbook:action.currentDownladingWorkbook?action.currentDownladingWorkbook:state.currentDownladingWorkbook,
				showWorkbookloader:action.showWorkbookloader
			}

			case ACTION_TYPES.SET_WORKBOOKSEXPORTED:
			return {
				...state,
				workbooksExported: action.workbooksExported || state.workbooksExported,
			}

			case ACTION_TYPES.SET_SETSHAREDWITHMEWORKBOOKS: 
			return {
				...state,
				sharedWithMeWorkBooks : action.sharedWithMeWorkBooks || state.sharedWithMeWorkBooks,
			}
			case ACTION_TYPES.SET_IS_WORKBOOK_IMPORTING:
				console.log(ACTION_TYPES.SET_IS_WORKBOOK_IMPORTING);
				return {
					...state,
					isWorkbookImporting: action.isWorkbookImporting,
				};
			case ACTION_TYPES.SET_IS_WORKBOOK_DELETING:
				return {
					...state,
					isWorkbookDeleting: action.isWorkbookDeleting
				}
			case ACTION_TYPES.SET_IS_WORKBOOKDATAFETCHED :
				return {
					...state,
					...(action.workbookListData && { workbookListData: action.workbookListData }),
					...(action.workbookIdListFromDB && { workbookIdListFromDB: action.workbookIdListFromDB }),
					isWorkbookListDataFetched: action.isWorkbookListDataFetched
				}
		default:
			return state;
	}
};

export default workbookReducer;